/**
 * CSRF token for Site API cookie sessions.
 *
 * The token is held in memory. After login/logout the server rotates the
 * session id, so callers must replace it with the value from the response
 * (or re-fetch `GET /csrf`).
 */

let csrfToken: string | null = null;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((listener) => listener());

export const csrfStore = {
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  get(): string | null {
    return csrfToken;
  },

  set(token: string | null) {
    csrfToken = token && token.length > 0 ? token : null;
    emit();
  },

  clear() {
    csrfToken = null;
    emit();
  },
};
